import { SpaceXxs, SpaceMd } from "@nxt-costco-com/forge-design-tokens";
const cardBodyContainerStyles = {
  display: "flex",
  flexDirection: "column",
  gap: SpaceXxs,
  height: "100%",
  position: "relative",
  width: "100%"
};
const cardBodyTextContentContainerStyles = {
  display: "flex",
  flexDirection: "column",
  gap: SpaceXxs,
  justifyContent: "flex-start"
};
const imageStyles = {
  marginBottom: SpaceMd
};
const childElementStyles = {
  zIndex: 2
};
const withSponsoredStyles = {
  display: "flex",
  height: "18px",
  justifyContent: "flex-end"
};
export {
  cardBodyContainerStyles,
  cardBodyTextContentContainerStyles,
  childElementStyles,
  imageStyles,
  withSponsoredStyles
};
